import { Box, Skeleton, Card } from "@mui/material";

const BadgesSkeleton = () => {
    return (
        <Box sx={{ mt: 3, mb: 1 }}>
            <Skeleton
                variant="text"
                width={80}
                height={24}
                sx={{
                    mb: 2,
                }}
            />
            <Box
                sx={{
                    display: "flex",
                    gap: 1.5,
                    overflowX: "hidden", // Hide scrollbar during loading
                    pb: 1,
                }}
            >
                {[1, 2, 3, 4].map((item) => (
                    <Card
                        key={item}
                        sx={{
                            minWidth: 130,
                            flexShrink: 0,
                            borderRadius: "12px",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
                            border: "1px solid #F2F2F2",
                            textAlign: "center",
                            p: 1.5,
                            bgcolor: "white",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                mb: 1,
                            }}
                        >
                            <Skeleton variant="circular" width={72} height={72} />
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}>
                            <Skeleton variant="text" width="80%" height={16} />
                            <Skeleton variant="text" width="60%" height={14} />
                        </Box>
                    </Card>
                ))}
            </Box>
        </Box>
    );
};

export default BadgesSkeleton;
